import type { DatePart } from '../utils/editorDate'

export const DATE_LOTTERY_FIELD_NAME = {
  Day: 'DAY',
  Month: 'MONTH',
  Year: 'YEAR',
} as const

export const DATE_PART_BY_FIELD_NAME: Record<string, DatePart> = {
  [DATE_LOTTERY_FIELD_NAME.Day]: 'day',
  [DATE_LOTTERY_FIELD_NAME.Month]: 'month',
  [DATE_LOTTERY_FIELD_NAME.Year]: 'year',
}
